define([
  'react',
  'prop-types',
  'underscore',
  'immutable',
  'es6!launcher/util/listbuilder/wysiwyg/util',
], (React, PropTypes, _, Immutable, WysiwygUtil) => {
  const { styleToPosition, isMobileBreakpoint } = WysiwygUtil;

  return Component => {
    // Calculates the bounding box of the popup components.
    class PopupMeasurement extends React.Component {
      static propTypes = {
        components: PropTypes.object,
      };

      static defaultProps = {
        components: Immutable.List(),
      };

      getCalculatedPopupBoundingBox() {
        const {
          components,
          breakpointSize,
          isPreview,
        } = this.props;
        const nonHiddenComponents = components.filter(c => c.get('type') !== 'hidden');
        let boundingBox;

        // No components means we have a zero bounding box.
        if (!nonHiddenComponents.count()) return { left: 0, top: 0, right: 0, bottom: 0 };

        // grid components don't have explicit sizes, so provide manually for scaling in wysiwyg
        if (nonHiddenComponents.getIn([0, 'type']) === 'gridRow' && isPreview) {
          if (isMobileBreakpoint(breakpointSize)) {
            boundingBox = {
              left: 0,
              top: 0,
              right: 500,
              bottom: 1000,
            };
          } else {
            boundingBox = {
              left: 0,
              top: 0,
              right: 1000,
              bottom: 500,
            };
          }
        } else {
          nonHiddenComponents.forEach(component => {
            const style = component.get('style');
            if (!style) return;

            const position = styleToPosition(style.toJS());

            position.right = position.left + position.width;

            if (['text', 'dropdown', 'countdown', 'checkbox'].indexOf(component.get('type')) > -1) {
              position.bottom = position.top;
            } else {
              position.bottom = position.top + position.height;
            }

            // If this is the first component, then we use that for our initial values.
            if (!boundingBox) {
              boundingBox = _.pick(position, 'left', 'top', 'right', 'bottom');
              return;
            }

            boundingBox.left = Math.min(boundingBox.left, position.left);
            boundingBox.right = Math.max(boundingBox.right, position.right);
            boundingBox.top = Math.min(boundingBox.top, position.top);
            boundingBox.bottom = Math.max(boundingBox.bottom, position.bottom);
          });
        }

        return boundingBox;
      }

      render() {
        const boundingBox = this.getCalculatedPopupBoundingBox();
        const popupWidth = boundingBox.right - boundingBox.left;
        const popupHeight = boundingBox.bottom - boundingBox.top;

        return (
          <Component
            {...this.props}
            width={popupWidth}
            height={popupHeight}
          />
        );
      }
    }

    return PopupMeasurement;
  };
});
